<template>
	<video crossorigin="anonymous" class="dots-bg" poster="@/images/dot-pattern.jpg" autoplay muted loop playsinline tabindex="-1" aria-hidden="true">
		<source src="/videos3/WhiteDotBG.mp4" type="video/mp4" />
	</video>
</template>
